var bg = "/static/389fba2559a11c0a.png";

export { bg as default };
//# sourceMappingURL=bg.png.js.map
